import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagsDropAssignService } from '../../services/tags-drop-assign.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { ManagementTagResponse } from 'api-clipping';
import { UtilsService } from '../../services/utils.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { state, style, trigger } from '@angular/animations';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-tag-dropzone',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatTooltipModule, MatIconModule, MatButtonModule, CdkDropList, CdkDrag],
	templateUrl: './tag-dropzone.component.html',
	animations: [
		trigger('showHide', [
			state(
				'show',
				style({
					display: 'inline-block',
				})
			),
			state(
				'hide',
				style({
					display: 'none',
				})
			),
		]),
	],
	styleUrl: './tag-dropzone.component.scss',
})
export class TagDropzoneComponent {
	@Input() id: string = '';
  @Input() tags: ManagementTagResponse[] = [];
  @Output() selectedTags: EventEmitter<any> = new EventEmitter();

	displayDeleteIcon!: string;

	constructor(public utils: UtilsService, public tagsDropAssign: TagsDropAssignService) {
		this.tagsDropAssign.updateTagDropzone.pipe(takeUntilDestroyed()).subscribe(response => {
      if (response.location === 'TAGZONE-FORM') {
				response.tags.forEach(droppedTag => {
					if (!this.tags.find(tag => tag.id === droppedTag.id)) {
						this.tags.push(droppedTag);
					}
				});
        this.selectedTags.emit({location: response.location, tags: this.tags});
			} else if (response.location === 'TAGZONE-LIST') {
        this.selectedTags.emit({location: response.location, tags: this.tags, itemId: response.itemId});
      }
		});
	}

	itemAction(action: 'REMOVE', tag: ManagementTagResponse) {
    this.tags = this.tags.filter(existingTag => existingTag.id !== tag.id);
    this.selectedTags.emit(this.tags);
  }
}
